import React from 'react';
import { Heading, HEADING_VARIANTS, Text, TEXT_VARIANTS } from 'ui/Typography';
import { Icon } from 'ui';

const GenericError = () => (
  <>
    <Text className="text-center" variant={TEXT_VARIANTS.SUBHEADER}>
      {t('common.something_went_wrong_on_our_end')}
    </Text>
    <Text className="text-center" variant={TEXT_VARIANTS.SUBHEADER}>
      {t('common.contact_support')}
    </Text>
  </>
);

const ErrorPage = () => {
  return (
    <div className="ai-c d-f fd-c mt-2 bg-white ErrorPage-main">
      <Icon
        name="404erroricon"
        className="ErrorPage-errorIcon"
        aria-label="Error Icon"
      />
      <Heading
        className="ErrorPage-heading"
        variant={HEADING_VARIANTS.H1_EXTRABOLD}
      >
        {t('common.oops')}
      </Heading>
      <div className="ErrorPage-headingBox" />
      <GenericError />
    </div>
  );
};

export default ErrorPage;
